module.exports = new __parcel__URL__("the-good-the-bad-and-the-ugly.0eb28486.jpg").toString();